import React from 'react'
import Honeybadger from 'honeybadger-js'
import { useStripe, useElements } from '@stripe/react-stripe-js'

import { scrollToTop } from 'components/shared/ScrollToTop'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      setErrorMessage // via redux actions
    } = props

    const stripe = useStripe()
    const elements = useElements()

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return null
    }

    const handleThrownError = errorClass => {
      return error => {
        Honeybadger.notify(error, errorClass)
        setErrorMessage(
          `An unexpected error occurred: ${errorClass}: ${error.message}`
        )
        scrollToTop()
      }
    }

    // Submit the Payment Element and create a ConfirmationToken
    const createConfirmationToken = async ({ onSuccess }) => {
      const { error: submitError } = await elements.submit()
      if (submitError) {
        setErrorMessage(submitError.message)
        scrollToTop()
        return
      }

      const { error, confirmationToken } = await stripe.createConfirmationToken(
        { elements }
      )
      if (error) {
        setErrorMessage(error.message)
        scrollToTop()
        return
      }

      onSuccess(confirmationToken)
    }

    // Provide a ConfirmationToken to the onSuccess callback
    const createStripeToken = ({ onSuccess }) => {
      createConfirmationToken({ onSuccess }).catch(
        handleThrownError('StripeConfirmationTokenError')
      )
    }

    return <WrappedComponent createStripeToken={createStripeToken} {...props} />
  }
}

export default withEventHandlers
